/* eslint-disable import/prefer-default-export */
/**
 * @deprecated use href or links instead
 * TODO: Re-check remove after ML-2501 <PB 2023-09-11 t:ML-2501>
 */
export const idFromHref = (href: string | null): number =>
  href ? +href.split('/').slice(-2, -1) : 0;
